<template>
	<div class="">
		<b-dropdown variant="outline-primary" class="m-2 gold">
			<template #button-content>
				<b-badge
					v-if="$store.state.notifications.bioTesting > 0"
					variant="danger"
					class="mr-1"
					v-text="$store.state.notifications.bioTesting"
				></b-badge>
				<span v-html="title"></span>
			</template>

			<b-dropdown-item href="/bioTesting/quizzes_submitted">
				<b-badge
					v-if="$store.state.notifications.bioTesting > 0"
					variant="danger"
					class="mr-1"
					v-text="$store.state.notifications.bioTesting"
				></b-badge>
				<i class="fas fa-home"></i> View Submitted Quizzes
			</b-dropdown-item>
			<b-dropdown-item href="/bioTesting/quizzes/edit"
				><i class="fas fa-pen"></i> Edit Quizzes
			</b-dropdown-item>
			<b-dropdown-item href="/bioTesting/quizzes/create"
				><i class="fas fa-plus-circle"></i> Start New Quiz
			</b-dropdown-item>
		</b-dropdown>
	</div>
</template>

<script>
export default {
	name: 'BioTestingButtons',
	components: {},
	props: {
		title: {
			type: String,
			default: 'Click Me',
		},
	},
	data() {
		return {};
	},
	mounted() {},

	computed: {},

	methods: {},

	watch: {},
};
</script>

<style scoped></style>
